import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (8.131 / 14);
  const localHeight = size * (13.617 / 14);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 8.131 13.617">
      <path
        d="M27.226,128.475a1.207,1.207,0,0,1-.856-.355l-5.71-5.71a1.211,1.211,0,0,1,0-1.712l5.485-5.485a1.211,1.211,0,1,1,1.712,1.712l-4.629,4.629,4.854,4.853a1.211,1.211,0,0,1-.856,2.067Z"
        transform="translate(-20.305 -114.858)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
